<template>
	<div class="relative">

		<div class="vx-navbar-wrapper" :class="classObj">

			<vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

				<!-- SM - OPEN SIDEBAR BUTTON -->
				<feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon"
							  @click.stop="showSidebar"/>

				<!--        <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->

				<vs-spacer/>

				<!-- <div> Поиск заказа по ID -->
				<div class="flex absolute start-1"
					v-if="($store.state.auth.role === 'manager' || $store.state.auth.role === 'admin' 
						|| $store.state.auth.role === 'author' || $store.state.auth.role === 'supervisor') 
						&& this.$route.path.includes('/ticket')"
				>
					<vs-input
						:placeholder="$t('placeholderGlovalSearchOrderById')"
						@keyup.enter.native="globalSearchOrderById"
						v-model="textGlobalSearchById"
						@input="acceptNumber"
					/>
					<vs-button
						class="fsrBtnGlobalSearchOrderById"
						size="small"
						icon-pack="feather"
						icon="search"
						@click="globalSearchOrderById"
					>
						<feather-icon icon="SearchIcon"></feather-icon>
					</vs-button>
				</div>
				<!-- </div> Поиск заказа по ID -->

				<!-- <div> Переключение между менеджерами -->
				<!-- <div class="flex" v-if="$store.state.auth.role === 'admin'">
					<v-select
						:clearable="false"
						v-model="selectedManagerLogin"
						class="single-row-select frsSelect"
						label="full_name"
						:options="listManager"
						:items="listManager"
						:placeholder="$t('chooseManager')"
						@input="onChangeSelectedManagerLogin"
					>      
						<template slot="selected-option" slot-scope="option">
							<span class="frsSelectSpanManagerNav">
								<img :src="option.photo" />
								{{ option.full_name }}
							</span>
						</template>
						<template #option="option">
							<span class="frsSelectSpanManagerNav">
								<img :src="option.photo" />
								{{ option.full_name }}
							</span>
						</template>
					</v-select>
				</div> -->
				<!-- </div> Переключение между менеджерами -->

				<!-- Баланс автора -->
				<div class="flex"
					v-if="$store.state.auth.role === 'author'"
				>
					<div class="m-5">
						<router-link class="text-black"  :to="'/finance'">
							<strong>{{ balanceAuthor }} &#8364;</strong>
						</router-link>
					</div>
				</div>

				<!-- Баланс менеджера -->
				<div class="flex"
					v-if="$store.state.auth.role === 'manager'"
				>
					<div class="m-5">
						<router-link class="text-black"  :to="'/finance'">
							<strong>{{ balanceManager }} &#8364;</strong>
						</router-link>
					</div>
				</div>

				<!-- Кнопка онлайн/офлайн для менеджеров -->
				<div class="flex"
					v-if="$store.state.auth.role === 'manager'"
					@click="changeStatusManager"
				>
					<div v-if="statusOnlineManager" class="fsrOnlineM text-sm">
						{{ $t('iAmOnline') }}
					</div>
					<div v-if="!statusOnlineManager" class="fsrOfflineM text-sm">
						{{ $t('iAmOffline') }}
					</div>
				</div>

				<!-- <search-bar class="mr-4"/> -->
				<!-- primary -->
				<vs-dropdown
					v-if="$store.state.auth.role !== 'client'"
					vs-custom-content
					vs-trigger-click
					:fixed="true"
					class="cursor-pointer mr-5"
				>

					<div class="con-img flex items-center  ml-3" v-if="$i18n.locale === 'de'">
						<img
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AgMAAADtUfddAAAACVBMVEUAAADdAAD/zgDGIigcAAAAHElEQVR4AWMAgVEwCkJxgRElMyqzChcYSTKjMgBDzfIcJWmM/AAAAABJRU5ErkJggg=="
							alt="de" width="22" height="14" class="">
						<span class="ml-2">{{ $t('german') }}</span>
					</div>
					<div class="con-img flex items-center  ml-3" v-else-if="$i18n.locale === 'it'">
						<img
							src="data:image/webp;base64,UklGRogAAABXRUJQVlA4THwAAAAvn4AaEE+gNACQBv4/jE6k7zjU6BuKYtug3vMJoIcA6ltqYS8EMwHI0EAEebWzFjuXYIraSIH2uwa4HWEVNWjAB/H/X3vu3VXvbhUNUyIRADA8bvISiiJJjbCACSzgCAsxcBo4Jc8rTyL6PwEBmoDrgem/9N+PFNAVrBME"
							alt="it" width="22" height="14" class="">
						<span class="ml-2">{{ $t('italian') }}</span>
					</div>

					<div class="con-img flex items-center  ml-3" v-else-if="$i18n.locale === 'fr'">
						<img
							src="data:image/webp;base64,UklGRogAAABXRUJQVlA4THwAAAAvn4AaEE+gppEUyMM9tFhAAP61UGPgbKiKbIO63p+6iCGkGmKIxEwDJBn4+UA97Z/IFA4jAZAwhA2sYSaPqCYPGI18HjcIkqr1tG6n2kFJMb/Py1soiiSpOQsJBCQFWMATArCA6XnxvIj+T8ACr4BVwfRf+u9HNvgOOBsI"
							alt="it" width="22" height="14" class="">
						<span class="ml-2">{{ $t('french') }}</span>
					</div>

					<div class="con-img flex items-center  ml-3" v-else>
						<svg version="1.1" id="Layer_1" width="22" xmlns="http://www.w3.org/2000/svg"
							 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
							 viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;"
							 xml:space="preserve">
							<path style="fill:#F5F5F5;" d="M512,200.093H0V97.104c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828
								L512,200.093L512,200.093z"/>
							<path style="fill:#FF4B55;" d="M503.172,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.909h512v102.988
								C512,419.773,508.047,423.725,503.172,423.725z"/>
							<rect y="200.091" style="fill:#41479B;" width="512" height="111.81"/>
						</svg>
						<span class="ml-2">{{ $t('russian') }}</span>
					</div>

					<vs-dropdown-menu :fixed="true" class="vx-navbar-dropdown">
						<ul style="min-width: 9rem">

							<li @click="changeLang('de')"
								class="flex py-2 items-center  px-4 cursor-pointer hover:bg-primary hover:text-white">
								<img
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8AgMAAADtUfddAAAACVBMVEUAAADdAAD/zgDGIigcAAAAHElEQVR4AWMAgVEwCkJxgRElMyqzChcYSTKjMgBDzfIcJWmM/AAAAABJRU5ErkJggg=="
									alt="de" width="22" height="14" class="">
								<span class="ml-2">{{ $t('german') }}</span>
							</li>
							<li @click="changeLang('it')"	
								class="flex items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
								<img
									src="data:image/webp;base64,UklGRogAAABXRUJQVlA4THwAAAAvn4AaEE+gNACQBv4/jE6k7zjU6BuKYtug3vMJoIcA6ltqYS8EMwHI0EAEebWzFjuXYIraSIH2uwa4HWEVNWjAB/H/X3vu3VXvbhUNUyIRADA8bvISiiJJjbCACSzgCAsxcBo4Jc8rTyL6PwEBmoDrgem/9N+PFNAVrBME"
									alt="it" width="22" height="14" class="">
								<span class="ml-2">{{ $t('italian') }}</span>
							</li>
							<li @click="changeLang('fr')"
								class="flex items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
								<img
									src="data:image/webp;base64,UklGRogAAABXRUJQVlA4THwAAAAvn4AaEE+gppEUyMM9tFhAAP61UGPgbKiKbIO63p+6iCGkGmKIxEwDJBn4+UA97Z/IFA4jAZAwhA2sYSaPqCYPGI18HjcIkqr1tG6n2kFJMb/Py1soiiSpOQsJBCQFWMATArCA6XnxvIj+T8ACr4BVwfRf+u9HNvgOOBsI"
									alt="it" width="22" height="14" class="">
								<span class="ml-2">{{ $t('french') }}</span>
							</li>
							<li @click="changeLang('ru')"
								class="flex items-center py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
								<svg version="1.1" id="Layer_1" width="22" xmlns="http://www.w3.org/2000/svg"
									 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
									 viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;"
									 xml:space="preserve">
									<path style="fill:#F5F5F5;" d="M512,200.093H0V97.104c0-4.875,3.953-8.828,8.828-8.828h494.345c4.875,0,8.828,3.953,8.828,8.828
										L512,200.093L512,200.093z"/>
									<path style="fill:#FF4B55;" d="M503.172,423.725H8.828c-4.875,0-8.828-3.953-8.828-8.828V311.909h512v102.988
										C512,419.773,508.047,423.725,503.172,423.725z"/>
									<rect y="200.091" style="fill:#41479B;" width="512" height="111.81"/>

								</svg>
								<span class="ml-2">{{ $t('russian') }}</span>
							</li>
						</ul>
					</vs-dropdown-menu>
				</vs-dropdown>

				<notification-drop-down/>

				<profile-drop-down/>

			</vs-navbar>
		</div>
		
		<ResultSearchGlobalOrderById
			:active.sync="showModalGlobalSearchOrderById"
			:orderNumber="textGlobalSearchById"
		/>
	</div>
</template>


<script>
import Bookmarks from './components/Bookmarks.vue'
import SearchBar from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import ResultSearchGlobalOrderById from "@/components/dialogs/ResultSearchGlobalOrderById";
import vSelect from "vue-select";

export default {
	name: 'the-navbar-vertical',
	mixins: [databaseManager, notifier],
	data() {
		return {
			textGlobalSearchById: '',
			showModalGlobalSearchOrderById: false,
			statusOnlineManager: true,
			balanceManager: 0,
			balanceAuthor: 0,
			listManager: [],
			selectedManagerLogin: null,
		}
	},
	props: {
		navbarColor: {
			type: String,
			default: '#fff'
		}
	},
	components: {
		Bookmarks,
		SearchBar,
		NotificationDropDown,
		ProfileDropDown,
		ResultSearchGlobalOrderById,
		vSelect,
	},
	watch:{
		$route(to, from) {
			// console.log(window.location.href);
			// console.log(this.$route.path);
			// console.log(this.$route.params);
		}
	},
	computed: {
		navbarColorLocal() {
			return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth
		},
		textColor() {
			return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
		},
		windowWidth() {
			return this.$store.state.windowWidth
		},

		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
			else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
			else if (this.verticalNavMenuWidth) return 'navbar-full'
		}
	},
	methods: {
		async onChangeSelectedManagerLogin() {
			try {
				// const url = `/admin/manager/get-token?email=${client.email}`;
				// const res = (await this.$http.get(url)).data.data;
				if(this.selectedManagerLogin.id > 0) {
					const res = await this.dbGetTokenManagerAsLogin(this.selectedManagerLogin.id);
					window.open(`/token/${res.role}/${res.token}`);
				}
			} catch(e) {
				this.notifyError(e.message);
			}
		},
		async getListManagerLogin() {
			this.listManager = await this.dbGetListMangersLogin();

			// console.log();

			// let manID = this.$store.state.auth.user;
			let manFind = null;

			this.listManager.forEach(function(elem) {
				if(elem.id == 0) {
					manFind = elem;
					return;
				}
			});
			this.selectedManagerLogin = manFind;
		},
		changeStatusManager() {
				if(this.statusOnlineManager) {
					this.$vs.dialog({
						type:'confirm',
						color: 'danger',
						title: this.$t('changeStatusManagerTitle'),
						text: this.$t('doYouWantStatusOfflineManager'),
						// accept: this.makeManagerDeletion(day, managerId),
						accept: this.switchOfflineManager,
						// parameters: [day, managerId],
						acceptText: this.$t('confirm'),
						cancelText: this.$t('cancel')
					});
				}
				if(!this.statusOnlineManager) {
					this.$vs.dialog({
						type:'confirm',
						color: 'success',
						title: this.$t('changeStatusManagerTitle'),
						text: this.$t('doYouWantStatusOnlineManager'),
						// accept: this.makeManagerDeletion(day, managerId),
						accept: this.switchOnlineManager,
						// parameters: [day, managerId],
						acceptText: this.$t('confirm'),
						cancelText: this.$t('cancel')
					});
				}
		},
		async switchOfflineManager() {
			try {
				this.statusOnlineManager = await this.dbSwitchOfflineManager();

				this.notifySuccess(this.$t("switchOfflineManagerNotification"));
			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		async switchOnlineManager() {
			try {
				this.statusOnlineManager =await this.dbSwitchOnlineManager();

				this.notifySuccess(this.$t("switchOnlineManagerNotification"));
			} catch (e) {
				this.notifyError(this.$t('errorNotification'));
			}
		},
		changeLang(locale) {
			this.$i18n.locale = locale;
			localStorage.setItem('locale', locale);
			this.$router.go(0);
		},
		showSidebar() {
			this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
		},
		async globalSearchOrderById() {
			if(this.textGlobalSearchById != '') {
				try {
					const res = await this.dbGetSearchGlobalOrderById(this.textGlobalSearchById);
					if(typeof res != "undefined" && typeof res.success != "undefined" && res.success == true) {
						this.$router.push({ name: 'order', params: { id: this.textGlobalSearchById  } });
						// this.$router.push('/ticket/'+this.textGlobalSearchById);
						this.textGlobalSearchById = '';
					} else {
						this.showModalGlobalSearchOrderById = true;
					}
				} catch (e) {
					this.textGlobalSearchById = '';
					this.notifyError(e.message);
				}
			}
		},
		acceptNumber() {
			const x = this.textGlobalSearchById.replace(/\D/g, '');
			// console.log('this.textGlobalSearchById:', this.textGlobalSearchById, 'x:', x);
			this.textGlobalSearchById = x;
		},
	},
	async mounted() {
		const role = this.$store.state.auth.role;

		if(role == 'manager') {
			this.statusOnlineManager = await this.dbGetStatusManager();
			this.balanceManager = (await this.$http.get('/' + this.$store.state.auth.role + '/stats/get-balance')).data.data.amount;
			// await this.getListManagerLogin();
		}

		if(role == 'author') {
			this.balanceAuthor = (await this.$http.get('/' + this.$store.state.auth.role + '/stats/get-balance')).data.data.amount;
		}
	}
}
</script>

<style lang="scss">
    .frsSelect {
		min-width: 210px;
		font-size: small;
		line-height: 20px;
		margin: auto;
	}
	.frsSelectSpanManagerNav {
        display: flex;
        line-height: 28px;
        font-size: small;
        color: black;
    
        img {
            width: 28px;
            margin-right: 10px;
        }	

    }
    .frsSelectSpanColorManagerNav {
        display: flex;
        line-height: 28px;
        font-size: small;
    }
    .align-center {
	    align-items: center;
    }
    .mini-img {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border-radius: 100%;
    }

	.vs-con-items {
		justify-content: left !important;
	}
	.fsrBtnGlobalSearchOrderById {
		width: 40px;
		padding: 0.4rem 1.25rem !important;
	}
	.fsrOnlineM {
		padding: 5px 10px;
		border: 5px solid #1a9915;
		border-radius: 30px;
		cursor: pointer;
		font-weight: bold;
	}
	.fsrOfflineM {
		padding: 5px 10px;
		border: 5px solid #e98057;
		border-radius: 30px;
		cursor: pointer;
		font-weight: bold;
	}
</style>